import React from 'react';
import ReactDOM from 'react-dom';

// Reactotron
import './config/ReactotronConfig';

import { Provider } from 'react-redux';

import { ConnectedRouter } from 'connected-react-router';

import App from './App';
import Routes from './routes';

import registerServiceWorker from './registerServiceWorker';

import store, { history } from './store';

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App>
        <Routes />
      </App>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);

registerServiceWorker();
